import React, { useEffect, useState } from "react";
import { Button, PlusIcon, SearchInput } from "evergreen-ui";
import { Table, Card, Drawer, message } from "antd";
import FireFetch from "../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { useListVals } from "../Firebase/databaseHooks";
import Firebase from "../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import AddStory from "../Modals/Stories/AddStory";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import EditStory from "../Modals/Stories/EditStory";
import ViewStory from "../Modals/Stories/ViewStory";
import { Document, Packer, Paragraph, SectionType, TextRun } from "docx";
import { saveAs } from 'file-saver';
import { utils, writeFile } from "xlsx";
import { useAuth } from "../AuthContext/AuthContext";
import TableActionMenu from "../Common/TableActionMenu";
import { getOrganizationName } from "../Firebase/dataCompat";

var db = getDatabase(Firebase);
var auth = getAuth(Firebase);
const moment = require("moment");

const SuccessStories = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateStory = canAccessModule("SUCCESS_STORIES", "create");
	const canUpdateStory = canAccessModule("SUCCESS_STORIES", "update");
	const canDeleteStory = canAccessModule("SUCCESS_STORIES", "delete");
	const columns = [
		{
			title: 'Story Title',
			dataIndex: 'title',
			key: 'title',
			ellipsis: true,
			sorter: (a, b) => a.title && a.title.localeCompare(b.title)
		},
		{
			title: 'Community',
			dataIndex: 'community',
			key: 'community',
			sorter: {
				compare: (a, b) => a.community && a.community.localeCompare(b.community),
			},
		},
		{
			title: 'Organization',
			dataIndex: 'orgID',
			key: 'orgID',
			sorter: {
				compare: (a, b) => a.orgID && a.orgID.localeCompare(b.orgID),
			},
		},
		{
			title: 'Language',
			dataIndex: 'language',
			key: 'language',
			sorter: {
				compare: (a, b) => a.language && a.language.localeCompare(b.language),
			},
		},
		{
			title: 'Submitted By',
			key: 'submittedBy',
			dataIndex: 'submittedBy',
			responsive: ["sm"],
			sorter: (a, b) => a.submittedBy && a.submittedBy.localeCompare(b.submittedBy)

		},
		{
			title: 'Story Topic',
			dataIndex: 'topic',
			key: 'topic',
			sorter: (a, b) => a.topic && a.topic.localeCompare(b.topic)
		},
		{
			title: 'Quote',
			dataIndex: 'quote',
			key: 'quote',
			ellipsis: true,
			sorter: (a, b) => a.quote && a.quote.localeCompare(b.quote)
		},
		{
			title: 'Created',
			dataIndex: 'created',
			key: 'created',
			sorter: (a, b) => moment(a.created, "DD/MMM/YYYY HH:MM").diff(moment(b.created, "DD/MMM/YYYY HH:MM"))
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	];
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [organizationArray] = useListVals(ref(db, "talmidsdb/organisations"));
	const [communityArray] = useListVals(ref(db, "talmidsdb/communities"));
	const [stories, loading] = useListVals(ref(db, "talmidsdb/successStories"));
	const [languages] = useListVals(ref(db, "talmidsdb/languages"));
	const [showModal, setShowModal] = useState(false);
	const [searchValue] = useState();
	const [checkedData, setCheckedData] = useState(false);
	const [dataArray, setDataArray] = useState([]);
	const [eventsData, setEventsData] = useState([]);
	const [viewModal, setViewModal] = useState(false);
	const [selectedStory, setSelectedStory] = useState(null);
	const [editModal, setEditModal] = useState(false);

	const callback = (data) => {
		setCheckedData(data);
	}
	useEffect(() => {
		setEventsData([]); setDataArray([]);
		onAuthStateChanged(auth, function (user) {
			if (user) {
				if (stories) {
					var tempArray = [];
					stories.map((item, index) => {
						tempArray.push({
							key: index,
							title: item.storyTitle,
							submittedBy: userArray.find(x => x.id === item.submittedBy)?.firstname
								+ " " + userArray.find(x => x.id === item.submittedBy)?.surname,
							orgID: getOrganizationName(
								organizationArray,
								item.organisationID || item.orgID,
								"Unknown organization"
							),
							community: communityArray.find(x => x.id === item.communityID)?.name,
							language: languages.find(x => x.id === item.languageID)?.languageName,
							quote: item.quote,
							topic: item.storyTopic,
							created: moment(item.dateCreated, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YY HH:MM"),
							action: (
								<TableActionMenu
									items={[
										{
											key: "view",
											label: "View",
											onClick: () => {
												setSelectedStory(item);
												setViewModal(true);
											},
										},
										canUpdateStory && {
											key: "edit",
											label: "Edit",
											onClick: () => {
												setSelectedStory(item);
												setEditModal(true);
											},
										},
										canDeleteStory && {
											key: "delete",
											label: "Delete",
											danger: true,
											onClick: () => {
												if (!canDeleteStory) {
													message.error("You do not have permission to delete stories.");
													return;
												}

												if (confirm("Are you sure you want to delete this Story?")) {
													FireFetch.DeleteFromDB("successStories", item.storyID)
														.then((msg) => {
															if (msg === "success") {
																FireFetch.addLog("SuccessStories", item.storyID, "Delete");
																message.success("Story deleted successfully");
															} else {
																message.error("Unable to delete story.");
															}
														})
														.catch(() => {
															message.error("An error occurred while deleting.");
														});
												}
											},
										},
									]}
								/>
							)
						});
					});
					setEventsData([...tempArray]);
					setDataArray([...tempArray]);
				}
			} else {
				// No user is signed in.
				window.location.href = "/login";
			}
		});
	}, [userArray, organizationArray, communityArray, stories]);

	const handleSearch = searchText => {
		const filteredEvents = dataArray.filter(({ submittedBy, orgID, community, language, quote, topic, title, created }) => {
			return submittedBy?.toLowerCase().includes(searchText.toLowerCase()) || (orgID?.toLowerCase().includes(searchText.toLowerCase()))
				|| community?.toLowerCase().includes(searchText.toLowerCase()) || language?.toLowerCase().includes(searchText.toLowerCase()) ||
				title?.toLowerCase().includes(searchText.toLowerCase()) || quote?.toLowerCase().includes(searchText.toLowerCase()) ||
				topic?.toLowerCase().includes(searchText.toLowerCase()) || created?.toLowerCase().includes(searchText.toLowerCase());
		});
		setEventsData(filteredEvents);
	};

	const printCSV = () => {
		var data = [selectedStory];
		console.log(data);
		const worksheet = utils.json_to_sheet(data);
		const workbook = utils.book_new();
		utils.book_append_sheet(workbook, worksheet, "successStory");
		writeFile(workbook, "Full Story.xlsx");
	}

	const printDOC = () => {
		selectedStory.maritalStatus = Array.isArray(selectedStory.maritalStatus) ? selectedStory.maritalStatus?.join(", ") : selectedStory.maritalStatus;
		selectedStory.submittedBy = userArray.find(x => x.id === selectedStory.submittedBy)?.firstname
			+ " " + userArray.find(x => x.id === selectedStory.submittedBy)?.surname;
		selectedStory.addedByUser = userArray.find(x => x.id === selectedStory.addedByUser)?.firstname
			+ " " + userArray.find(x => x.id === selectedStory.addedByUser)?.surname;
		selectedStory.organisation = getOrganizationName(
			organizationArray,
			selectedStory.organisation,
			selectedStory.organisation
		);
		selectedStory.community = communityArray.find(x => x.communityID === selectedStory.community)?.name;
		selectedStory.language = languages.find(x => x.languageID === selectedStory.language)?.language;

		var attributeArray = Object.entries(selectedStory);
		var sectionArray = [];
		attributeArray.map((attribute) => {

			var sectionObject = {
				properties: {
					type: SectionType.CONTINUOUS,
				},
				children: [
					new Paragraph({
						children: [
							new TextRun({
								text: attribute[0],
								bold: true,
							})
						],
					}),
					new Paragraph({
						children: [
							new TextRun({
								text: attribute[1],
							})
						],
					}),
					new Paragraph({
						children: [
							new TextRun({
								text: " ",
							})
						],
					}),
				],
			}
			sectionArray.push(sectionObject);
		})

		const doc = new Document({
			styles: {
				paragraphStyles: [
					{
						id: "wellSpaced",
						name: "Well Spaced",
						basedOn: "Normal",
						quickFormat: true,
						paragraph: {
							spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
						},
					},
				],
			},
			sections: sectionArray
		});

		// Used to export the file into a .docx file
		Packer.toBlob(doc).then((blob) => {
			// saveAs from FileSaver will download the file
			saveAs(blob, "successStory.docx");
		});
	}

	return (
		<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
			<Drawer title="New Story"
				width={500}
				className="font-Nunito"
				shouldCloseOnOverlayClick={false}
				maskClosable
				placement="right" onClose={() => { setShowModal(false) }}
				visible={showModal}>
				<AddStory modal={setShowModal} />
			</Drawer>
			<Drawer title="Edit Story"
				width={500}
				className="font-Nunito"
				shouldCloseOnOverlayClick={false}
				maskClosable
				placement="right" onClose={() => { setEditModal(false) }}
				visible={editModal}>
				<EditStory modal={setEditModal} story={selectedStory} />
			</Drawer>
			<Drawer title={
				<div className="d-flex flex-row justify-content-between">
					<b>View Story</b>
					<div>
						<Button className="mx-1" appearance="primary" onClick={() => {
							printCSV()
						}}>
							Print(CSV)
						</Button>
						<Button className="mx-1" appearance="primary" onClick={() => {
							printDOC();
						}}>
							Print(DOC)
						</Button>
					</div>
				</div>
			}
				width={800}
				className="font-Nunito"
				shouldCloseOnOverlayClick={false}
				placement="right" onClose={() => { setViewModal(false) }}
				visible={viewModal}>
				<ViewStory modal={setViewModal} story={selectedStory} />
			</Drawer>
			<MDBRow className="w-100">
				<MDBCol md={12}>
					<Card className="w-100">
						<MDBRow>
							<MDBCol md={12}>
								<div className="text-left">
									<div className="d-flex flex-row justify-content-between">
										<div className="d-inline">
											<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
												<Text family='Nunito'>
													Success Stories
												</Text>
											</h5>
										</div>
										<div className="d-flex flex-row">
											<SearchInput placeholder="Filter through stories" onChange={e => handleSearch(e.target.value)} value={searchValue} />
											{canCreateStory && (
												<Button appearance="primary" className="mx-2" onClick={() => {
													setShowModal(true);
												}}>
													New Story <PlusIcon />
												</Button>
											)}
											<Button appearance="primary" className="mx-2" onClick={() => {
												FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
													filename: "SuccessStories",
													exportButtons: false,
													sheetname: "SuccessStories",
												}), eventsData);
											}}>
												Print
											</Button>
										</div>
									</div>
								</div>
							</MDBCol>
						</MDBRow>
					</Card>
					<Card>
						<Table id="dataTable"
							className="custom-table"
							style={{ overflow: "auto" }}
							pagination={{
								defaultPageSize: 100,
								showSizeChanger: true, pageSizeOptions: ['100', '200', '300']
							}}
							loading={loading} columns={columns} dataSource={eventsData} />
					</Card>

				</MDBCol>
			</MDBRow>
		</div>
	);
}

export default SuccessStories;
